// This is needed in order to avoid gatsby to scroll to the top, below the sticky header.
import styled from 'styled-components';

export const FakeHeader = styled.div`
  height: 50px;
`;
